(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets-order-home/assets/javascript/order-home-router.js') >= 0) return;  svs.modules.push('/modules/tickets-order-home/assets/javascript/order-home-router.js');
"use strict";

const {
  useRouteMatch
} = ReactRouterDOM;
const {
  Route
} = svs.app.ReactRouter;
const {
  Choose,
  Receiver,
  Preview,
  PreviewCoverletter,
  Message,
  Confirmation
} = svs.ticketsOrderHome.pages;
const {
  OrderHomeProvider
} = svs.ticketsOrderHome.context;
const {
  LoginRequiredRoute
} = svs.ticketsOrderHome.components;
const NavigationBack = svs.tur.NavigationBack;
const branding = svs.tickets.data.templateConfig.branding === 'triss' ? 'triss' : null;
const {
  InstructionsInfo
} = svs.ticketsOrderHome.components;
const {
  DIVIDER
} = svs.ticketsOrderHome.routes;
const {
  CHOOSE,
  RECEIVER,
  PREVIEW_COVERLETTER,
  PREVIEW,
  MESSAGE,
  CONFIRMATION
} = svs.ticketsOrderHome.routes.ORDER_HOME;
const routes = history => ({
  [CHOOSE]: {
    text: 'Beställ hem/',
    navigate: () => history.push(DIVIDER)
  },
  [RECEIVER]: {
    text: 'Beställ hem/',
    navigate: () => history.push(CHOOSE)
  },
  [PREVIEW]: {
    text: 'Beställ hem/',
    navigate: () => history.push(CHOOSE)
  },
  [PREVIEW_COVERLETTER]: {
    text: 'Beställ hem/',
    navigate: () => history.push(MESSAGE)
  },
  [MESSAGE]: {
    text: 'Beställ hem/',
    navigate: () => history.push(RECEIVER)
  },
  [CONFIRMATION]: {
    text: 'Beställ hem/',
    navigate: () => history.push(CHOOSE)
  }
});
const breadcrum = 'Köp lotter';
const cancelUrl = "".concat(svs.core.data.baseUrl).concat(CHOOSE);
const Instructions = () => {
  const isOnDividerPage = useRouteMatch(DIVIDER);
  const isOnConfirmationPage = useRouteMatch(CONFIRMATION);
  if (isOnDividerPage !== null && isOnDividerPage !== void 0 && isOnDividerPage.isExact) {
    return null;
  }
  return React.createElement("div", {
    className: "bg-white need-help-min-height padding-h-1 ".concat(isOnConfirmationPage !== null && isOnConfirmationPage !== void 0 && isOnConfirmationPage.isExact ? 'padding-v-1' : 'padding-v-3')
  }, React.createElement(InstructionsInfo, {
    showStepByStep: !(isOnConfirmationPage !== null && isOnConfirmationPage !== void 0 && isOnConfirmationPage.isExact)
  }));
};
const OrderHomeRouter = () => {
  const {
    useHistory
  } = ReactRouterDOM;
  const history = useHistory();
  return React.createElement(OrderHomeProvider, null, React.createElement(React.Fragment, null, React.createElement(NavigationBack, {
    brand: branding,
    breadcrum: breadcrum,
    routes: routes(history)
  }), React.createElement(Route, {
    component: Choose,
    exact: true,
    path: CHOOSE
  }), React.createElement(LoginRequiredRoute, {
    cancelUrl: cancelUrl,
    component: Preview,
    exact: true,
    path: PREVIEW
  }), React.createElement(React.Fragment, null, React.createElement(LoginRequiredRoute, {
    cancelUrl: cancelUrl,
    component: Receiver,
    exact: true,
    path: RECEIVER
  }), React.createElement(LoginRequiredRoute, {
    cancelUrl: cancelUrl,
    component: Message,
    exact: true,
    path: MESSAGE
  }), React.createElement(LoginRequiredRoute, {
    cancelUrl: cancelUrl,
    component: PreviewCoverletter,
    exact: true,
    path: PREVIEW_COVERLETTER
  })), React.createElement(LoginRequiredRoute, {
    cancelUrl: cancelUrl,
    component: Confirmation,
    exact: true,
    path: CONFIRMATION
  }), React.createElement(Instructions, null)));
};
setGlobal('svs.ticketsOrderHome.OrderHomeRouter', OrderHomeRouter);

 })(window);